import React from 'react';

import Icon from '../Icon';

export const booleanPrinter = () => {
  return function BooleanPrinter({ item, itemKey }) {
    return <span>{item[itemKey] && <Icon name="ok" />}</span>;
  };
};
